/* Generated by ./script/iconify.js */
/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import IconBase from './IconBase'
import classnames from 'classnames'

const IconEnvelope = ({ className, ...rest }) => {
  const classes = classnames(
    'icon',
    'icon--envelope',
    className,
  )

  return (
    <IconBase className={classes} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 16"{...rest}><path className="path1" fill="#FFF" d="M18.327 0H2.037C.916 0 .01.9.01 2L0 14c0 1.1.916 2 2.036 2h16.291c1.12 0 2.037-.9 2.037-2V2c0-1.1-.917-2-2.037-2zm0 4l-8.145 5-8.146-5V2l8.146 5 8.145-5v2z"/></IconBase>
  )
}

IconEnvelope.propTypes = {
  className: PropTypes.string,
}

export default IconEnvelope
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/icons/IconEnvelope.js